export enum UserRoles {
  "ADMIN", "USER", "CTO"
}
export interface FirebaseUser extends StamplingUser {
  role: string;
  is_manager: boolean;
}

export interface StamplingUser {
  id: string;
  name: string;
  email?: string;
  cardid?: string;
  tone?: string;
  group?: string;
  workday?: number;
}



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/models/User.ts